import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/home/Index.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/about-me',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '@/views/about/Index.vue'),
  },
  {
    path: '/portfolio',
    name: 'Portfolio',
    component: () => import(/* webpackChunkName: "porfolio" */ '@/views/portfolio/Index.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
